import { Icon } from '@/components/ui/Icon'
import styles from './Badge.module.scss'

export type BadgeVariant =
  | 'default'
  | 'primary'
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'solid-success'
  | 'solid-error'

interface BadgeProps {
  text: string
  variant?: BadgeVariant
  icon?: string
  className?: string
  testId?: string
}

export const Badge = ({
  text,
  variant = 'default',
  icon,
  className = '',
  testId,
}: BadgeProps) => {
  return (
    <span
      className={`${styles.badge} ${styles[variant]} ${className}`}
      data-testid={testId}
    >
      {icon && <Icon name={icon} size={12} className={styles.icon} />}
      {text}
    </span>
  )
}
